import { type Budget, ExpenseType } from '@subaio/api-types/budget'

/** Removes all user adjustments from the budget, that means all `*userProvided` will be set to `null`
 * and all expenses with the `type` set to `"UserProvided"` will be filtered out. */
export const removeUserAdjustments = (budget: Budget): Budget => ({
	...budget,
	categories: budget.categories.map((category) => ({
		...category,
		totalMonthlyAmountUserProvided: null,
		categories: category.categories.map((subcategory) => ({
			...subcategory,
			totalMonthlyAmountUserProvided: null,
			expenses: subcategory.expenses.filter(({ type }) => type !== ExpenseType.UserProvided),
		})),
	})),
	income: budget.income.map((category) => ({
		...category,
		income: category.income.filter(({ type }) => type !== ExpenseType.UserProvided),
	})),
	disposableIncomeUserProvided: null,
	amountCategorizedUserProvided: null,
	totalMonthlyAmountUserProvided: null,
	totalMonthlyIncomeUserProvided: null,
})
